import { render } from "./PageTag.vue?vue&type=template&id=b307a9fc&scoped=true"
import script from "./PageTag.vue?vue&type=script&lang=js"
export * from "./PageTag.vue?vue&type=script&lang=js"

import "./PageTag.vue?vue&type=style&index=0&id=b307a9fc&scoped=true&lang=css"

import exportComponent from "/prj/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b307a9fc"]])

export default __exports__